export function KwaipilotIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.85696 5.23567V3.67767H2.96203H1.1806V11.7644V12.1692V13.3224H3.85696V11.7644H2.96203V5.23567H3.85696Z"
        fill="white"
      />
      <path
        d="M13.038 3.67764H12.1431V5.23564H13.038V11.7643H12.1431V13.3223H14.8195V12.1692V11.7643V3.67764H13.038Z"
        fill="#32EDDA"
      />
      <path d="M8.69039 3.67764L8.38168 5.42784H6.64709L6.95581 3.67764H8.69039Z" fill="#32EDDA" />
      <path d="M9.35829 6.4585L8.14744 13.3223H6.41406L7.62371 6.4585H9.35829Z" fill="#32EDDA" />
      <path
        d="M9.35867 6.4585L8.14783 13.3223H12.1431V11.7643H13.0381V6.4585H9.35867Z"
        fill="url(#paint0_linear_5226_23341)"
        fillOpacity="0.34"
      />
      <path
        d="M6.64752 5.42786L7.62413 6.45852H9.35871L8.3821 5.42786H6.64752Z"
        fill="url(#paint1_linear_5226_23341)"
        fillOpacity="0.54"
      />
      <path
        d="M8.69043 3.67764H12.1428V5.23564H13.0377V6.4585H9.35832L8.38171 5.42784L8.69043 3.67764Z"
        fill="url(#paint2_linear_5226_23341)"
        fillOpacity="0.82"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5226_23341"
          x1="8.71401"
          y1="8.5913"
          x2="12.012"
          y2="9.58216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32EDDA" />
          <stop offset="1" stopColor="#32EDDA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5226_23341"
          x1="7.45379"
          y1="5.36979"
          x2="7.5351"
          y2="6.36572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32EDDA" />
          <stop offset="1" stopColor="#B392F3" stopOpacity="0.180392" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5226_23341"
          x1="8.63638"
          y1="3.33769"
          x2="10.1361"
          y2="4.65541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32EDDA" />
          <stop offset="1" stopColor="#32EDDA" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
